import "@fontsource/lato";
import "@fontsource-variable/roboto-flex";
import "@fontsource/google-sans-flex";

import "assets/css/app.css";
import "assets/css/theme.css";
import { purgeLegacyStorageKeys } from "helpers/scopedStorage";
import AppRenderer from "./AppRenderer";

const render = (): void => {
	purgeLegacyStorageKeys();
	AppRenderer();
};

render();